// extracted by mini-css-extract-plugin
var _1 = "CollapseIcon_icon__ddf7a";
var _2 = "CollapseIcon_isOpen__22859";
var _3 = "CollapseIcon_left__13e15";
var _4 = "CollapseIcon_right__725c6";
export { _1 as "icon", _2 as "isOpen", _3 as "left", _4 as "right" }
